import { AccessorsMutatorsDecorator } from "../../helpers";
import { TranslatableModel } from "./translatable-model";

export class ChannelManagerTariffSettings extends TranslatableModel {}

AccessorsMutatorsDecorator(
    'one_time_setup_fee',
    'room_rate',
    'min_number_of_rooms'
)(ChannelManagerTariffSettings);


// WEBPACK FOOTER //
// ./src/pms-api/models/channel-manager-tariff-settings.model.js